module.exports = __webpack_public_path__ + "img/restaurant.61990044.svg";